import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface SchoolRequestData {
  district_name: string
  school_name: string
  requester_email: string
  additional_notes?: string
}

export const useSchoolRequestMutation = () => {
  return useMutation({
    mutationFn: async (data: SchoolRequestData) => {
      const res = await fetch(`${URL}/schools/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })

      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.detail || 'Failed to submit school request')
      }

      return await res.json()
    },
    onError: (error) => {
      console.error('School request error:', error)
      toast.error(error.message)
    },
    onSuccess: () => {
      toast.success('School request submitted successfully')
    },
  })
}
